module.exports = {
  PAGE_VIEWED: 'Landing_Page_Viewed',
  START_TRIAL_CLICKED: 'Start_Trial_Clicked',
  PRICING_PLAN_CLICKED: 'Pricing_Plan_Clicked',
}
